import { render } from "./StockView.vue?vue&type=template&id=1cfc8d9b&scoped=true&ts=true"
import script from "./StockView.vue?vue&type=script&lang=ts"
export * from "./StockView.vue?vue&type=script&lang=ts"

import "./StockView.vue?vue&type=style&index=0&id=1cfc8d9b&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfc8d9b"]])

export default __exports__